import { COLORS } from '@/constants';
import styled, { css } from 'styled-components';

export const AccordionContainer = styled.div<{ $borderless?: boolean }>`
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 6px;
  width: 100%;
  box-shadow: none;

  &:hover {
    border: 1px solid ${COLORS.orange};
  }
`;

export const AccordionHeader = styled.div`
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
`;

export const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: 0;
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    padding 0.3s ease;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      border-top: 1px solid ${COLORS['neutral/300']};
      max-height: 10000px;
      overflow: visible;
      padding: 6px 10px 10px;
    `}
`;

export const FiltersContainer = styled.div`
  display: grid;
  gap: 12px;
`;

export const LabelWithHint = styled.span`
  white-space: nowrap;
`;

export const ArrowIcon = styled.svg<{ $isOpen: boolean }>`
  width: 17px;
  height: 16px;
  transition: transform 0.3s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};

  path {
    fill: #647daf;
  }
`;
